import { z } from 'zod';
import { LogIngestRequestSchema, } from '@pillar-portal/api-types';
const TraceHeaderSchema = z.string().min(1);
export class PillarLogTransportCore {
    getPortalUrl;
    getRequestHeaders;
    getTraceContextHeader;
    customFetch;
    constructor(config) {
        this.getPortalUrl = config.getPortalUrl;
        this.getRequestHeaders = config.getRequestHeaders ?? (async () => ({}));
        this.getTraceContextHeader = config.getTraceContextHeader ?? (() => null);
        this.customFetch = config.customFetch;
    }
    async send(entry, options) {
        await this.sendBatch([entry], options);
    }
    async sendBatch(entries, _options) {
        const payload = LogIngestRequestSchema.parse({
            entries,
        });
        const requestHeaders = await this.getRequestHeaders();
        const traceHeaderValue = this.getTraceContextHeader();
        const traceHeader = traceHeaderValue
            ? TraceHeaderSchema.parse(traceHeaderValue)
            : undefined;
        const logIngestUrl = buildLogIngestUrl(this.getPortalUrl());
        const body = JSON.stringify(payload);
        const fetchImplementation = this.customFetch ?? globalThis.fetch;
        const response = await fetchImplementation(logIngestUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                ...requestHeaders,
                ...(traceHeader ? { 'X-Cloud-Trace-Context': traceHeader } : {}),
            },
            credentials: 'include',
            body,
        });
        if (!response.ok) {
            const responseText = await response.text();
            throw new Error(`PILLAR log ingestion failed: ${response.status} ${response.statusText} ${responseText}`);
        }
    }
}
function buildLogIngestUrl(portalUrl) {
    const baseUrl = portalUrl.endsWith('/') ? portalUrl : `${portalUrl}/`;
    const url = new URL('api/portal/v1/logs', baseUrl);
    return url.toString();
}
//# sourceMappingURL=index.js.map